import React, { useEffect } from "react";
import { getCustomerMe } from "../api/customerPortal";
import { createAuthStore } from "../lib/createAuthStore";

export const useCustomerAuthStore = createAuthStore({
  tokenKey: "customer_token",
  refreshKey: "customer_refresh_token",
  userKey: "customer_data",
  fetchMe: getCustomerMe,
  onLoadError: "retry", // interceptor may have refreshed the token — retry once, then clear
});

export function CustomerAuthProvider({ children }) {
  const load = useCustomerAuthStore(s => s.load);
  useEffect(() => { load(); }, [load]);
  return <>{children}</>;
}

export function useCustomerAuth() {
  const s = useCustomerAuthStore();
  return {
    customer: s.user, loading: s.loading, isAuthenticated: !!s.user,
    loginCustomer: (token, refreshToken, customerData) => s.setSession(token, refreshToken, customerData),
    logoutCustomer: s.clearSession,
  };
}
